import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import Button from "../Button";
import {useMessages} from "../../hooks/useMessages";
import Icon from "../Icon";
import {getTheme} from "../../shared/themeUtils";

const Content = styled.div`
  .content {
    overflow: hidden;
    position: relative;

    .content-overlay {
      height: ${getTheme("space.3")};
      width: 100%;
      background: linear-gradient(0deg, rgba(255,255,255,1), rgba(255,255,255,0));
      position: absolute;
      bottom: 0;
    }
  }

  button {
    padding-left: 0;
    display: inline-block;
    color: ${getTheme("colors.link")};
    text-decoration: none;
    font-weight: 400;
    
    .button-content {
      display: flex;
      width: 100%;
      justify-content: center;
      
      .direction-icon {
        margin-right: ${getTheme("space.0")};
      }
    }
  }
`

const ShowMore = ({children}: any) => {
  const [showMore, setShowMore] = useState(false);
  const contentRef = useRef(null);
  const [buttonVisible, setButtonVisible] = useState(false);
  const [elHeight, setElHeight] = useState("0px");
  const [showMoreText, setShowMoreText] = useState("...")
  const [showLessText, setShowLessText] = useState("...")
  const messagesQuery = useMessages()

  useEffect(() => {
    if (messagesQuery.data) {
      setShowMoreText(messagesQuery.data.messages["show-more"])
      setShowLessText(messagesQuery.data.messages["show-less"])
    }

    setElHeight(getHeight());
    // @ts-ignore
    if (contentRef.current?.clientHeight > 80) {
      setButtonVisible(true)
    }
  }, [messagesQuery.data])

  const getHeight = () => {
    //@ts-ignore
    return contentRef.current?.clientHeight < 80 ? contentRef.current?.clientHeight + "px" : "80px";
  }

  return (
    <Content>
      {/*@ts-ignore*/}
      <div id="content" className="content" style={{"height": showMore ? "auto" : elHeight}} >

        <div ref={contentRef}>{children}</div>

        {(!showMore && buttonVisible) && <div className="content-overlay"></div>}
      </div>
      {buttonVisible && <Button variant={"underline"}
        onClick={() => setShowMore(!showMore)}>
        {(!showMore && messagesQuery.data) && <span className="text-capitalize button-content">
          <Icon className="direction-icon" variant="xSmall" color={"link"}>
            arrow-down-line
          </Icon>
          {showMoreText}
        </span>}
        {(showMore && messagesQuery.data) && <span className="text-capitalize button-content">
          <Icon className="direction-icon" variant="xSmall" color={"link"}>
            arrow-up-line
          </Icon>
          {showLessText}
        </span>}
      </Button>}
    </Content>
  )
}

export default ShowMore;
